module.exports = __webpack_public_path__ + "img/fi-water-side-rest.8975b4fb.jpg";